export const isEmailInvalidFormat = (value) => !new RegExp(/[^@]+@[^@]+$/).test(value);

export const isEmailInvalidFormatLoginhub = (value) => {
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return !emailRegex.test(value);
};

export const isFieldEmpty = (fieldState) => !fieldState.value;

export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_NO_CONTENT = 204;
export const HTTP_STATUS_BAD_REQUEST = 400;
export const HTTP_STATUS_UNAUTHORIZED = 401;
export const HTTP_STATUS_INTERNAL_SERVER_ERROR = 500;

/**
 * Produces an array with booleans controlling whether the error message corresponding to a
 * user input should be shown.
 *
 * @param inputStates array containing the states of user input in OneStepForm or TwoStepForm
 * @returns array containing booleans. The element corresponding to the first erroneous input is set to true,
 * whereas all other elements are set to false.
 */
export function showFirstErrorArray(inputStates) {
	const hasError = inputStates.map(state => state.error.message && state.error.show);
	const firstErrorIndex = hasError.findIndex(it => it === true);
	return hasError.map((_, index) => index === firstErrorIndex);
}

export function showAllErrorsArray(inputStates) {
	return inputStates.map(state => !!state.error.message && state.error.show);
}


export const isValidationErrorResponse = (response) => response.errors;

export const isValidationLoginHubErrorResponse = (response) => response.error;

export const isResponseWithSuggestions = (response) => response.nicknameSuggestions;

export const handleNicknameValidity = (nicknameValidationResult, dispatch, invalidResultCallbackFn) => {
	if (nicknameValidationResult && nicknameValidationResult.length > 0) {
		dispatch({ type: 'SET_NICKNAME_ERROR', payload: nicknameValidationResult[0].message });
		dispatch({ type: 'SHOW_NICKNAME_ERROR' });
		dispatch({ type: 'SET_NICKNAME_VALIDITY', payload: false });

		invalidResultCallbackFn && invalidResultCallbackFn();
	}
};

export const handlePasswordValidity = (passwordValidationResult, dispatch, invalidResultCallbackFn) => {
	if (passwordValidationResult && passwordValidationResult.length > 0) {
		dispatch({ type: 'SET_PASSWORD_ERROR', payload: passwordValidationResult[0].message });
		dispatch({ type: 'SHOW_PASSWORD_ERROR' });
		dispatch({ type: 'SET_PASSWORD_VALIDITY', payload: false });

		invalidResultCallbackFn && invalidResultCallbackFn();
	}
};

export const handlePasswordValidityWithInvalidNickname = (passwordValidationResult, dispatch, invalidResultCallbackFn) => {
	if (passwordValidationResult && passwordValidationResult.length > 0) {
		dispatch({ type: 'SET_PASSWORD_ERROR', payload: passwordValidationResult[0].message });
		dispatch({ type: 'HIDE_PASSWORD_ERROR' });
		dispatch({ type: 'SET_PASSWORD_VALIDITY', payload: false });

		invalidResultCallbackFn && invalidResultCallbackFn();
	}
};

export const handleEmailValidity = (emailValidationResult, dispatch, invalidResultCallbackFn) => {
	if (emailValidationResult && emailValidationResult.length > 0) {
		dispatch({ type: 'SET_EMAIL_ERROR', payload: emailValidationResult[0].message });
		dispatch({ type: 'SHOW_EMAIL_ERROR' });
		dispatch({ type: 'SET_EMAIL_VALIDITY', payload: false });

		invalidResultCallbackFn && invalidResultCallbackFn();
	}
};

export const handleNicknameSuggestions = (result, dispatch) => {
	dispatch({ type: 'SET_NICKNAME_SUGGESTIONS', payload: result.nicknameSuggestions });
};
